import {
  DoGood,
  InternalHero,
  PetLandingPageType,
  Pricing,
  Questions,
  Reviews,
  TakeBetterCare,
  ValuePoints,
  WhatIsCovered,
} from '@/components/pet';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config, type Config } from '@/pageConfig/pet/cats/us/en';
import { PET_LANDING_PAGE } from '@/utils/productAdaPages';
import { PRODUCT_PET } from '@/utils/products';
import { useEffect } from 'react';

const extraAnalyticsParams = {
  pet_lp_type: PetLandingPageType.Cat,
  variant: PetLandingPageType.Cat,
};

export default function CatsPage({
  dynamicHeroTitle,
  dynamicConfig,
  dynamicAnalyticsParams,
}: {
  dynamicHeroTitle?: string;
  dynamicConfig: Config;
  dynamicAnalyticsParams?: Record<string, string>;
}) {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        ...extraAnalyticsParams,
        ...dynamicAnalyticsParams,
      }),
    [],
  );

  const finalConfig = dynamicConfig != null ? dynamicConfig : config;
  return (
    <Layout
      headerActions={finalConfig.layout.headerActions}
      product={PRODUCT_PET}
      page={PET_LANDING_PAGE}
      productType={PRODUCT_PET}
      menuCheckPricesExtraAnalyticsParams={{
        ...extraAnalyticsParams,
      }}
    >
      <SEO {...finalConfig.seo} />
      <PageWrapper>
        <InternalHero petLandingPageType={PetLandingPageType.Cat} dynamicHeroTitle={dynamicHeroTitle} />
        <ValuePoints petLandingPageType={PetLandingPageType.Cat} />
        <WhatIsCovered petLandingPageType={PetLandingPageType.Cat} />
        <TakeBetterCare petLandingPageType={PetLandingPageType.Cat} />
        <Pricing petLandingPageType={PetLandingPageType.Cat} />
        <Reviews petLandingPageType={PetLandingPageType.Cat} />
        <Questions petLandingPageType={PetLandingPageType.Cat} />
        <DoGood petLandingPageType={PetLandingPageType.Cat} />
      </PageWrapper>
    </Layout>
  );
}
